<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import TencentCloudChat from "@tencentcloud/chat";
import TIMUploadPlugin from "tim-upload-plugin";
import { detectEnvAsync, ENV } from '@/utils/env';
import common from "./service/common";
import { generateUserSig } from "./service/api"; // 小程序构建npm引入
import { getLinkParam,findMascotByUserId } from "./service/h5-api";
import store from "./store/index";
import VConsole from 'vconsole';
import eventBus from '@/utils/event-bus'
import {getPageQuery} from '@/utils/common.ts'
// 创建 sdk 实例
uni.$TUIKit = TencentCloudChat.create({
	SDKAppID: "1400802351",
});
//// 设置 SDK 日志输出级别，生产环境时建议使用1
uni.$TUIKit.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
uni.$TIM = TencentCloudChat;

// 注册文件上传插件
uni.$TUIKit.registerPlugin({
	"tim-upload-plugin": TIMUploadPlugin,
});
import login from "@/mixins/login";

export default {
	onLaunch: async function(option) {
		// uni.hideTabBar()

		uni.$checkLogin = false;
		console.log('App Launch===', option);
		//记录当前页面地址
		await common.sharePath(option.path, option.query);
		// 获取商城链接参数并存储全局
		try {
			const res = await getLinkParam();
			if (res.code == 0) {
				getApp().globalData.mallInfo =  res.data;
			}
			console.log("获取商城信息",getApp().globalData.mallInfo)
		} catch (error) {
			console.error('获取商城信息失败', error);
		}
		//获取app主题
		try {
			const userId = getPageQuery().userId || uni.getStorageSync('wxUserInfoSync').id
			findMascotByUserId({userId}).then(res => {
                console.log('获取app主题-app.vue===',res)
                if (res && res.data) {
					//设置app主题
					const themeName = res.data.name + "Theme";
					uni.setStorageSync('currentTheme', themeName)
					// 通过store设置主题
					store.dispatch('theme/switchTheme', themeName).catch(() => {
						// 如果主题不存在，使用默认主题
						store.dispatch('theme/switchTheme', 'catTheme');
					});
					console.log("设置app主题-app.vue===", res.data.name)
				} else {
					// 如果没有获取到主题数据，初始化默认主题
					store.dispatch('theme/initTheme');
				}
            }).catch(error => {
				console.error('获取app主题失败', error);
				// 获取失败时使用默认主题
				store.dispatch('theme/initTheme');
			});
		} catch (error) {
			console.error('获取app主题失败', error);
			// 异常时使用默认主题
			store.dispatch('theme/initTheme');
		}
		//埋点
		common.mdTrack("", "进入app.vue", "{}");
		//TIMLogin等于0则不加载im
		if(option.query.TIMLogin!=0){
			//小程序im登陆
			await common.wxLogin(this.imLogin);
		}
		this.bindTIMEvent();

		detectEnvAsync().then(env => {
			console.log('当前的环境是啥环境====》', env)
			// 跑在了微信小程序的webview中
			if (env === ENV.WX_MINIPROGRAM_WEBVIEW && process.env.NODE_ENV != 'production') {
				new VConsole();
			}else{
				// 其他情况
				this.$jsbridge.getNativeInfo({'param': "你好，这是我JS传递给你的数据"}).then(data => {
					// || process.env.NODE_ENV === 'development'
					if (data.vConsole) {
						new VConsole();
					}
				})
			}
		})
		window.addEventListener('unhandledrejection', (event) => {
			console.log(event);
		});
	},
	mixins: [login],
	onShow: function () {
		// console.log("App Show");
	},
	/*
	全局变量：checkLogin-app.js的onLaunch执行完之后再执行Page的onLoad，

	*/
	globalData: {
		mallInfo: {
			tenantId: "",
			ssoId: "",
		},
	},
	methods: {
		onMessageReceived(event) {
			console.log('app.vue;监听到新消息-----', event);
			//消息为当前的群消息，同步到页面
			var cloudData =  event.data[0].cloudCustomData && /^{.*}$/.test(event.data[0].cloudCustomData)
							? JSON.parse(event.data[0].cloudCustomData)
							: {};
			if('GROUP' +uni.getStorageSync('TIMGroupID') == event.data[0].conversationID && cloudData.type != '201'){
				event.data.forEach((item) => {
					const messageList = [...store.state.messageList, item];
					// 更新 messageList
					store.commit('setMessageList', messageList);
				});
				//滚动聊天页面
				store.commit('SET_IS_ROLL', true);
			}
			//移除群4，删除群5
			if(uni.getStorageSync('TIMGroupID') && event.data[0].type == 'TIMGroupSystemNoticeElem' && ([4,5]).indexOf(event.data[0].payload?.operationType) != -1){
				// uni.showToast({
				// 	title: "您已被移出群聊！",
				// 	icon: "none",
				// });
				setTimeout(()=>{
					//isStaff：0用户，1医生
					if (uni.getStorageSync('wxUserInfoSync').isStaff == 1) {
						// uni.reLaunch({
						// 	url: '/pagesChat/doctor/index',
						// });
						uni.reLaunch({
							url: '/pages/index/index',
						});
					} else if (uni.getStorageSync('wxUserInfoSync').isStaff == 0) {
						uni.reLaunch({
							url: '/pages/index/index',
						});
					}
				},3000)
			}
			//群系统通知
			this.timGroupSystem(event.data)
			this.parseCloudCustomData(event.data)
			//"{"type":"REJECT","result":"您好，您邀请的专家程沛拒绝邀请，请确认是否更换其他专家？","groupId":"hb_qa@15436","role":"ROLE_DOCTOR","customerId":15436,"consultId":30014,"extend":{"type":"RECEIVES","consultId":30014,"groupId":"hb_qa@15436","userId":88,"role":"ROLE_DOCTOR","isManualInvite":true,"inviterId":717}}"
			// if(event.conversationType=='c2c' && cloudCustomData.type =='REJECT'){
			// 	uni.showToast({
			// 		title: cloudCustomData.result,
			// 		icon: "none",
			// 	});
			// }
			
		},
		//群系统通知-数据处理
		timGroupSystem(data){
			if (Array.isArray(data)) {
				for (const item of data) {
					this.timGroupSystem(item);
				}
				return;
			}
			if(data.type=="TIMGroupSystemNoticeElem"){
				switch (data.payload?.operationType) {
					case 4: // 移除群
						common.groupSort(data)
						return
					case 5: // 删除群
						common.groupSort(data)
						return
				}
			}
		},
		//自定义消息处理
		parseCloudCustomData(data){
			if (Array.isArray(data)) {
				for (const item of data) {
					this.parseCloudCustomData(item);
				}
				return;
			}
			const parseData =
						data.cloudCustomData && /^{.*}$/.test(data.cloudCustomData)
							? JSON.parse(data.cloudCustomData)
							: {};
			console.log("自定义消息处理-----",data,parseData)
			switch (parseData?.type) {
				case '101': // 选择机构
					store.commit('SET_INSTITUTION', parseData);
					break
				case '201': // 流式问答
					console.log("流式问答==========")
					//不在当前聊天群内
					if('GROUP' +uni.getStorageSync('TIMGroupID') !== data.conversationID)return;
					let extData = parseData?.extend;
					let wxChatExtList = store.state.wxChatExtList || [];
					console.log("type201本地的缓存=====",wxChatExtList)
					//是否存过
					let isSaved = false;
					//数据角标
					let extIndex = 0;
					let extItem = {}
					if(wxChatExtList.length>0){
						(wxChatExtList || []).map(item=>{
							if(item.fromMsgSeq == extData.fromMsgSeq){
								isSaved = true
								extIndex = item.extIndex
								extItem = item;
								console.log("数据角标",wxChatExtList,item)
							}
						})
					}
					console.log("是否存过",isSaved,extIndex)
					console.log("是否存过==角标",extIndex)
					try{
						if(isSaved){
							console.log("存在时===messageList",JSON.parse(JSON.stringify(store.state.messageList)))
							if(!store.state.messageList[extIndex]?.ID)return;
							var desc = store.state.messageList[extIndex]?.payload.text || "";
							data.ID = extItem.ID;
							data.payload.text = desc + extData.message;
							store.commit('setMessageIndex', {'index':extIndex , data});
						}else{
							extIndex = store.state.messageList.length || 0;
							console.log("不存在时===extIndex",extIndex)
							console.log("不存在时===messageList",JSON.parse(JSON.stringify(store.state.messageList)))
							store.commit('SET_WX_CHAT_EXT_DATA', [
								...wxChatExtList,{
								type:'201',
								fromMsgSeq: extData.fromMsgSeq,
								extIndex,
								ID:data.ID,
							}]);
							data.payload.text = extData.message;
							console.log(extIndex,"不存在时======",store.state.messageList.length,data)
							store.commit('setMessageIndex', {'index':extIndex , data});
						}
					}catch(e){console.log(e)}
					if(extData.end){
						console.log("流式问答结束==========")
						store.commit('SET_WX_CHAT_EXT_DATA',wxChatExtList.filter(item=>item.fromMsgSeq != extData.fromMsgSeq));
					}
					break
				case '301':
					// 接收到大屏演示类型通知
					store.dispatch('LSMessageProcessing', parseData)
					break
				case '601':
					// 接收到图片识别结果通知
					eventBus.$emit('imageRecognitionResult', parseData)
					break
				default:
					break
			}
		},
		onConversationListUpdated(event) {
			console.log("app.vue;监听会话列表更新", event);
			// let list = [];
			// for (const item of event.data) {
			// 	if (item.type === "GROUP") {
			// 		if (
			// 			item.conversationID ==
			// 			"GROUP" + uni.getStorageSync("TIMGroupID")
			// 		) {
			// 			item.unreadCount = 0;
			// 		}
			// 		list.push(item);
			// 	}
			// }
			// console.log("会话列表==",event);
			store.commit("setConversationList", event.data);
		},
		onRevokeMessage(event){
			// console.log('app.vue;收到消息被撤回的通知', event);
		},
		//监听好友列表更新
		onFriendListUpdated(event){
			console.log('app.vue;监听好友列表更新', event);
		},
		onGroupListUpdated(event){
			// console.log('app.vue;群事件监听', event);
		},
		bindTIMEvent() {
			uni.$TUIKit.on(uni.$TIM.EVENT.SDK_READY, this.handleSDKReady);
			// uni.$TUIKit.on(uni.$TIM.EVENT.SDK_NOT_READY, this.handleSDKNotReady);
			uni.$TUIKit.on(uni.$TIM.EVENT.KICKED_OUT, this.handleKickedOut);
			//im推送的单聊、群聊、群提示、群系统通知的新消息
			uni.$TUIKit.on(uni.$TIM.EVENT.MESSAGE_RECEIVED,this.onMessageReceived);
			//监听会话列表更新事件
			uni.$TUIKit.on(uni.$TIM.EVENT.CONVERSATION_LIST_UPDATED,this.onConversationListUpdated);
			//收到消息被撤回的通知
			uni.$TUIKit.on(uni.$TIM.EVENT.MESSAGE_REVOKED,this.onRevokeMessage);
			//群事件监听
			uni.$TUIKit.on(uni.$TIM.EVENT.GROUP_LIST_UPDATED, this.onGroupListUpdated);
			//监听好友列表更新
			uni.$TUIKit.on(uni.$TIM.EVENT.FRIEND_LIST_UPDATED, this.onFriendListUpdated);
			//会话未读总数更新，event.data 是当前单聊和群聊会话的未读总数。
			uni.$TUIKit.on(uni.$TIM.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, this.onTotalUnreadMessageCountUpdated);
		},
		// sdk ready 以后可调用 API
		handleSDKReady(event) {
			console.log('全局--sdk ready 以后可调用 API',event);
			this.$store.commit('SET_IS_SIGN', true);
		},
		handleSDKNotReady(event) {
			// console.log("SDK 未完成初始化");
			uni.showToast({
				title: "SDK 未完成初始化",
				icon: "none",
			});
		},

		handleKickedOut(event) {
			// uni.clearStorageSync();
			uni.showToast({
				title: `${this.kickedOutReason(
					event.data.type
				)}被踢出，请重新登录。`,
				icon: "none",
			});
			console.warn(
				`${this.kickedOutReason(
					event.data.type
				)}被踢出，请重新登录。请根据自己的需求在 IM 控制台打开多平台登录`
			);
		},

		kickedOutReason(type) {
			switch (type) {
				case uni.$TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
					return "多实例登录";
				case uni.$TIM.TYPES.KICKED_OUT_MULT_DEVICE:
					return "多设备登录";
				case uni.$TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
					return "userSig 过期";
				case uni.$TIM.TYPES.KICKED_OUT_REST_API:
					return " REST API kick 接口踢出";
				default:
					return "";
			}
		},
		onTotalUnreadMessageCountUpdated(event) {
			console.log("app.vue;监听会话未读总数更新", event);
			this.$store.commit('SET_UNREAD_COUNT', true);
		},
	},
	onHide: function () {
		// console.log("App Hide");
	},
};
</script>

<style lang="scss">
@import "@/static/scss/config.scss";
@import '@/uni_modules/uv-ui-tools/index.scss';
@import "@/static/scss/theme-classes.scss";

page {
	width: 100%;
	height: 100%;
	-webkit-touch-callout: none !important;
	-webkit-user-select: none !important;	
}
#__vconsole {
	-webkit-touch-callout: none !important;
	-webkit-user-select: none !important;	
}
</style>